import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import * as AppPics from 'assets/images';
import '../../../assets/css/reorder_custom.css';
import useReorderCategoryList from 'hooks/API/GET/useReorderCategoryList';
import useReOrderCategory from 'hooks/API/POST/useReorderCategory';
import { notifier } from 'components/Toaster';
import { useQueryClient } from 'react-query';
import { ReactSortable } from 'react-sortablejs';
import { AppButton } from 'components';

function ReorderCategory() {
  const history = useHistory();
  const queryClient = useQueryClient();

  const [categories, setCategories] = useState([]);
  const [previousOrder, setPreviousOrder] = useState([]);

  const { data: categoryData, isLoading } = useReorderCategoryList({
    enabled: true,
    config: { params: {} },
    queryKey: ['podcast-category-reorder'],
  });

  const { mutate: reorderCategories, isLoading: isSaving } = useReOrderCategory();

  useEffect(() => {
    if (Array.isArray(categoryData)) {
      const sortedCategories = [...categoryData].sort(
        (a, b) => (a.sortPosition || 0) - (b.sortPosition || 0)
      );
      setCategories(sortedCategories);
      setPreviousOrder(sortedCategories.map((cat) => cat.id));
    }
  }, [categoryData]);

  const handleCategoryReOrder = (newCategories) => {
    if (isSaving) return;

    // Create the payload array with id and sortPosition
    const reorderPayload = newCategories.map((category, index) => ({
      id: category.id,
      sortPosition: index + 1,
    }));

    reorderCategories(reorderPayload, {
      onSuccess: (res) => {
        notifier.success(res?.data?.message || 'Genre reordered successfully');
        queryClient.invalidateQueries('podcast-category');
        queryClient.invalidateQueries('podcast-reorder-category');
        // Update previous order after successful save
        setPreviousOrder(newCategories.map((cat) => cat.id));
      },
      onError: (err) => {
        notifier.error(err?.response?.data?.message || 'Failed to reorder categories');
        // Revert to original order on error
        if (Array.isArray(categoryData)) {
          const sortedCategories = [...categoryData].sort(
            (a, b) => (a.sortPosition || 0) - (b.sortPosition || 0)
          );
          setCategories(sortedCategories);
        }
      },
    });
  };

  const handleSortEnd = (newList) => {
    setCategories(newList);

    // Check if the order actually changed
    const currentOrder = newList.map((cat) => cat.id);
    const hasOrderChanged = !currentOrder.every((id, index) => id === previousOrder[index]);

    // Only call API if order actually changed
    if (hasOrderChanged) {
      handleCategoryReOrder(newList);
    }
  };

  const handleBackNavigation = () => {
    history.push('/podcast/category');
  };

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <AppButton variantClass="btn-back" onClick={handleBackNavigation}>
              <img src={AppPics.BackSvg} alt="Back" />
            </AppButton>
          </li>
          <li className="active">Reorder Genre</li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Podcast Home', to: '/podcast' },
                { label: 'Genre', to: '/podcast/category' },
              ]}
              current="Reorder Genre"
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              <div className="tab__contentMenu mb-4">
                <h2 className="prime-head p-0 boldtitle text-nowrap">Reorder Podcast Genre</h2>
              </div>
              <div className="tab__contentBody mt-4">
                {isLoading ? (
                  <div className="text-center py-5">
                    <p>Loading categories...</p>
                  </div>
                ) : categories.length === 0 ? (
                  <div className="text-center py-5">
                    <p className="text-muted">No categories available to reorder.</p>
                  </div>
                ) : (
                  <ReactSortable
                    list={categories}
                    setList={handleSortEnd}
                    handle=".categoryGrabHandleID"
                    disabled={isSaving}
                  >
                    {categories.map((category) => (
                      <div className="row mt-3" key={category?.id}>
                        <div className="col-12">
                          <div className="lessonWrap saved lessonWrap--border categoryGrabHandleID position-relative">
                            {/* Status badge */}
                            {category?.section && (
                              <span className={`category-badge ${category?.section}`}>
                                {category?.section === 'trending' ? 'Trending' : 'Popular'}
                              </span>
                            )}
                            <div className="lessonWrap__text">
                              <div className="d-flex align-items-center category-content">
                                <div className="category-info flex-grow-1">
                                  <span className="lessonWrap__name d-block">{category?.name}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </ReactSortable>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReorderCategory;
